/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cleanProps = _interopRequireDefault(require("../../../../common/cleanProps"));
var _join = _interopRequireDefault(require("../utils/join"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Item = function (_Component) {
  (0, _inherits2.default)(Item, _Component);
  var _super = _createSuper(Item);
  function Item(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Item);
    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(Item, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        selected = _this$props.selected,
        rootClassName = _this$props.rootClassName,
        selectedStyle = _this$props.selectedStyle,
        active = _this$props.active,
        background = _this$props.background,
        item = _this$props.item,
        index = _this$props.index,
        disabledStyle = _this$props.disabledStyle,
        disabledClassName = _this$props.disabledClassName,
        activeStyle = _this$props.activeStyle,
        activeClassName = _this$props.activeClassName,
        selectedClassName = _this$props.selectedClassName,
        renderItem = _this$props.renderItem,
        rtl = _this$props.rtl,
        itemHeight = _this$props.itemHeight,
        itemEllipsis = _this$props.itemEllipsis;
      var disabled = item.disabled;
      var className = (0, _join.default)(this.props.className, rootClassName, selected && "".concat(rootClassName, "--selected"), rtl && "".concat(rootClassName, "--rtl"), active && "".concat(rootClassName, "--active"), disabled && "".concat(rootClassName, "--disabled"), itemEllipsis && "".concat(rootClassName, "--ellipsis"), disabled && disabledClassName, active && activeClassName, selected && selectedClassName);
      var style = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.props.style), active && activeStyle), disabled && disabledStyle), selected && selectedStyle);
      if (itemHeight) {
        style.height = itemHeight;
      }
      if (background) {
        style.background = background;
      }
      var label = this.props.label;
      var matchText = item.matchText;
      if (typeof label === 'string' && matchText) {
        label = matchText.map(function (textPart, index) {
          if ((0, _typeof2.default)(textPart) === 'object') {
            return _react.default.createElement("span", {
              className: "".concat(rootClassName, "__highlight"),
              key: index
            }, textPart.match);
          }
          return textPart;
        });
      }
      var domProps = _objectSpread(_objectSpread({}, (0, _cleanProps.default)(this.props, Item.propTypes)), {}, {
        style: style,
        className: className,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        children: label
      });
      var result;
      if (typeof renderItem === 'function') {
        result = renderItem({
          domProps: domProps,
          label: label,
          item: item,
          index: index
        });
      }
      if (result === undefined) {
        result = _react.default.createElement("div", _objectSpread({}, domProps));
      }
      return result;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      event.preventDefault();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.props.item.disabled) {
        return null;
      }
      this.props.onClick(this.props.id);
    }
  }]);
  return Item;
}(_react.Component);
function emptyFn() {}
Item.defaultProps = {
  onClick: emptyFn,
  selectedStyle: {},
  item: {}
};
Item.propTypes = {
  rootClassName: _propTypes.default.string,
  itemHeight: _propTypes.default.number,
  itemEllipsis: _propTypes.default.bool,
  renderItem: _propTypes.default.func,
  selectedClassName: _propTypes.default.string,
  selectedStyle: _propTypes.default.object,
  background: _propTypes.default.string,
  active: _propTypes.default.bool,
  label: _propTypes.default.node,
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  item: _propTypes.default.object,
  onClick: _propTypes.default.func,
  index: _propTypes.default.number,
  rtl: _propTypes.default.bool,
  disabledStyle: _propTypes.default.object,
  disabledClassName: _propTypes.default.string,
  activeStyle: _propTypes.default.object,
  activeClassName: _propTypes.default.string
};
var _default = Item;
exports.default = _default;